(function () {
  function initFindDropSwiper(el) {
    if (!el || typeof Swiper === 'undefined') return;

    return new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 12,
      loop: false,
      navigation: {
        nextEl: el.parentElement.querySelector('.disco-find__swiper-next'),
        prevEl: el.parentElement.querySelector('.disco-find__swiper-prev'),
      },
      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });
  }

  function setup() {
    document.querySelectorAll('.disco-find__swiper').forEach(function (el) {
      initFindDropSwiper(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
